import { render } from "./MTextArea.vue?vue&type=template&id=6273ef90&scoped=true&ts=true"
import script from "./MTextArea.vue?vue&type=script&lang=ts"
export * from "./MTextArea.vue?vue&type=script&lang=ts"

import "./MTextArea.vue?vue&type=style&index=0&id=6273ef90&scoped=true&lang=scss"

import exportComponent from "/Users/kameyamanaoki/dev/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6273ef90"]])

export default __exports__